import { ProgressItem } from '../../../../../../../global/components/navigation/generic-stepper';
import { NewHireProps } from '../../../../../models/arc-epi-props';
import { Employment } from '../../../../employment/employment-model';
import { PensionEnrollmentInfo } from '../../../../pension-enrollment/models/pension-enrollment-model';
import { CoverageValidationSchemaModel } from '../../../enrollment/models/coverage-models';
import { MemberCompensation, memberScheduleHoursHighThreshold } from '../../../models/new-hire-enrollment-models';
import { NewHireEnrollmentRoutes } from '../../../models/new-hire-routes';
import { BenefitEnrollmentStep } from '../../../models/pension-enrollment-models';
import { MemberNewHireEnrollmentCoverage, MemberPendingCoverage } from '../../models/member-coverage-model';

function memberHasGHLEnrollments(memberNewHireEnrollmentCoverage: MemberNewHireEnrollmentCoverage): boolean {
	return !!memberNewHireEnrollmentCoverage?.coverage?.pending?.medical || !!memberNewHireEnrollmentCoverage?.coverage?.pending?.dental || 
			!!memberNewHireEnrollmentCoverage?.coverage?.pending?.short_term_disability || !!memberNewHireEnrollmentCoverage?.coverage?.pending?.long_term_disability || 
			!!memberNewHireEnrollmentCoverage?.coverage?.pending?.UEI ||
			!!memberNewHireEnrollmentCoverage?.coverage?.complete?.medical || !!memberNewHireEnrollmentCoverage?.coverage?.complete?.dental || 
			!!memberNewHireEnrollmentCoverage?.coverage?.complete?.short_term_disability || !!memberNewHireEnrollmentCoverage?.coverage?.complete?.long_term_disability || 
			!!memberNewHireEnrollmentCoverage?.coverage?.complete?.UEI;
}

function memberHasRetirementPlans(pensionEnrollmentInfo: PensionEnrollmentInfo): boolean {
	return pensionEnrollmentInfo?.enrolled_plans?.length > 0;
}

function memberOnlyOTPScheduledHoursLow(memberCompensation: MemberCompensation, employment: Employment): boolean {
	const memberScheduledHoursHigh = Number(employment?.current_scheduled_hours) >= memberScheduleHoursHighThreshold;

	return (!memberScheduledHoursHigh && !(memberCompensation?.compensations?.length > 0) && (memberCompensation?.otp.length > 0));
}

export function shouldMemberNavigateRetirementStep(pensionEnrollmentInfo: PensionEnrollmentInfo, memberCompensation: MemberCompensation, employment: Employment): boolean {
	
	if (memberOnlyOTPScheduledHoursLow(memberCompensation, employment)) return false;

	return memberHasRetirementPlans(pensionEnrollmentInfo);
}

export function shouldMemberNavigateCoverageStep(memberCompensation: MemberCompensation, employment: Employment, memberNewHireEnrollmentCoverage: MemberNewHireEnrollmentCoverage): boolean{

	if (memberOnlyOTPScheduledHoursLow(memberCompensation, employment)) return false;

	return memberHasGHLEnrollments(memberNewHireEnrollmentCoverage);	
}

export function getMemberBenefitEnrollmentSteps(memberNewHireEnrollmentCoverage: MemberNewHireEnrollmentCoverage, memberCompensation: MemberCompensation, employment: Employment, pensionEnrollmentInfo: PensionEnrollmentInfo) {

	const steps = [];

	if (shouldMemberNavigateRetirementStep(pensionEnrollmentInfo, memberCompensation, employment)){
		steps.push(BenefitEnrollmentStep.RETIREMENT);
	}

	if (shouldMemberNavigateCoverageStep(memberCompensation, employment, memberNewHireEnrollmentCoverage)){
		steps.push(BenefitEnrollmentStep.COVERAGE);
	}

	steps.push(BenefitEnrollmentStep.REVIEW);	

	return steps;
}

export function getMemberBenefitEnrollmentStepItems(settings: NewHireProps, memberNewHireEnrollmentCoverage: MemberNewHireEnrollmentCoverage, memberCompensation: MemberCompensation, employment: Employment, pensionEnrollmentInfo: PensionEnrollmentInfo) {
	const progressItem: ProgressItem[] = [];
	
	if (shouldMemberNavigateRetirementStep(pensionEnrollmentInfo, memberCompensation, employment)){
		progressItem.push(
			{
				stepName: settings?.offeredPlanStepName,
				linkUrl: NewHireEnrollmentRoutes.Retirement,
				step: BenefitEnrollmentStep.RETIREMENT,
			},
		);
	}

	if (shouldMemberNavigateCoverageStep(memberCompensation, employment, memberNewHireEnrollmentCoverage)){
		progressItem.push(
			{
				stepName: settings?.offeredCoverageStepName,
				linkUrl: NewHireEnrollmentRoutes.Coverage,
				step: BenefitEnrollmentStep.COVERAGE,
			},
			);
	}
	
	progressItem.push(
		{
			stepName: settings?.reviewStepName,
			linkUrl: NewHireEnrollmentRoutes.Coverage,
			step: BenefitEnrollmentStep.REVIEW,
		},
	);

	return progressItem;
}


export function GetMemberValidationModel(coverageState: MemberPendingCoverage): CoverageValidationSchemaModel {
	return {
		hasMedical: coverageState?.medical?.plans?.length > 0,
		hasDental: coverageState?.dental?.plans?.length > 0,
		hasGroup: coverageState?.group_life?.plans?.length > 0,
		hasLtd: coverageState?.long_term_disability?.plans?.length > 0,
		hasStd: coverageState?.short_term_disability?.plans?.length > 0,
		hasUei: coverageState?.UEI?.plans?.length > 0,
	};
}